import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { AuthService } from "../../main/auth.service";
import { environment } from "../../../environments/environment";
import { ArkUserType, ReleaseNotesViewModel, ReleaseItemViewModel } from "../../core/api/models";
import { HttpClient } from "@angular/common/http";
import { Utils } from "../../core/utils";
import { AlertService } from "../../shared/services/alert.service";
import { ReleaseNotesApiService } from "../../core/api/services";
import { Table, TableRowCollapseEvent, TableRowExpandEvent } from "primeng/table";
import { formatDate } from "@angular/common";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";


@Component({
  selector: 'app-release-notes-component',
  templateUrl: './release-notes.component.html',
  styleUrl: './release-notes.component.css',
  standalone: false
})
export class ReleaseNotesComponent implements OnInit, AfterViewInit {

  public pageTitle: string = 'Release Notes';


  filter: any = {};
  list: ReleaseNotesViewModel[] = [];
  loadingList: boolean = true;
  loadingDetails: boolean = false;

  loadingPrepareReleaseItems: boolean = false;
  loadingReleaseToProduction: boolean = false;
  loadingArchiveReleaseItems: boolean = false;
  

  loadingCurrentItem: boolean = false;
  currentItem?: ReleaseNotesViewModel;
  currentItemID?: number;

  expandedRows: any = {};

  @ViewChild('dt1') table?: Table;
  @ViewChild('dt2') table2?: Table;
  constructor(private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private alertService: AlertService,
    private apiService: ReleaseNotesApiService,) {
  }


  ngOnInit(): void {
    this.route.paramMap.subscribe((params: ParamMap) => {
      this.currentItemID = +(params.get('ID') || '0');
      if (this.currentItemID > 0) {
        console.info('Loading ' + this.currentItemID);

        this.loadingCurrentItem = true;
        this.apiService.Get({ body: { id: this.currentItemID } })
          .forEach(data => {
            this.loadingCurrentItem = false;
            this.currentItem = data;
            this.pageTitle = `#${this.currentItem.Number} - ${this.currentItem.Title}`;

          }).catch(
            err => {
              this.loadingCurrentItem = false;
              this.alertService.error(Utils.getAjaxError(err));

            });

      }
    });

    this.authService.checkIfAutorized([ArkUserType.Support, ArkUserType.Admin]);
    
  }
    
  ngAfterViewInit(): void {
    if (!this.currentItem && !this.loadingCurrentItem)
      this.loadTable(null);
  }


  loadTable(event: any) {

    if (event || !this.filter) {
      this.filter = Utils.normalizePrimeDatatableEvent(event || this.filter || { filters: {} });
    }
    this.expandedRows = [];
    this.loadingList = true;
    this.apiService.List({ body: this.filter })
      .forEach(
        (result) => {
          this.list = result;
          this.loadingList = false;
        }).catch(
          err => {
            this.alertService.error(Utils.getAjaxError(err));
            this.loadingList = false;
          });
  }


  cancel() {

    if (this.currentItemID) {
      this.router.navigate(['/releasenotes']);
      return;
    }

    this.currentItem = undefined;
    if (!this.list)
      this.loadTable(null);
  }

  clear(table: Table) {
    this.table = table;
    table.clear();
  }

  getLink(item: ReleaseNotesViewModel) {
    return `https://github.com/UTBS/${item.Repository}/pull/${item.Number}`;
  }

  getItemLink(item: ReleaseItemViewModel) {
    if (item.ItemType == "Pull Request")
      return `https://github.com/UTBS/${item.Repository}/pull/${item.Number}`;
    else
      return `https://github.com/UTBS/${item.Repository}/issues/${item.Number}`;
  }

  getItemPRLink(item: ReleaseItemViewModel) {
    if (item.PRNumber)
      return `https://github.com/UTBS/${item.Repository}/pull/${item.PRNumber}`;
    return 'javascript:void(0);';
  }

  getBadgetClass(item: ReleaseItemViewModel) {
    if (!item || !item.ItemType)
      return '';
    if (item.ItemType == 'Bug')
      return 'badge bg-danger   text-dark';

    if (item.ItemType == 'How To')
      return 'badge bg-info  text-dark';

    if (item.ItemType == 'Feature Request')
      return 'badge bg-success';

    if (item.ItemType == 'Permission Request')
      return 'badge bg-success';

    if (item.ItemType == 'General')
      return 'badge bg-secondary';

    return 'badge bg-primary';
  }


  onRowExpand(event: TableRowExpandEvent<ReleaseNotesViewModel>) {
    console.debug('onRowExpand', event, this.expandedRows);

    if (!event.data.Items) {
      this.loadingDetails = true;
      this.apiService.Get({ body: { id: event.data.Number } })
        .forEach(
          (result) => {
            event.data.Items = result.Items;
            event.data.ReviewId = result.ReviewId;
            event.data.ReviewAuthor = result.ReviewAuthor;
            event.data.ReviewDate = result.ReviewDate;
            event.data.Review = result.Review;
            event.data.ReleaseNotesCommentId = result.ReleaseNotesCommentId;
            event.data.ReleaseNotesAuthor = result.ReleaseNotesAuthor;
            event.data.ReleaseNotesDate = result.ReleaseNotesDate;
            event.data.ReleaseNotes = result.ReleaseNotes;
            var i = this.list?.findIndex(x => x.Number === event.data.Number);
            if (this.list && i !== undefined && i !== -1) {
              this.list[i] = result;
            }
            this.loadingDetails = false;
          }).catch(
            err => {
              this.alertService.error(Utils.getAjaxError(err));
              this.loadingDetails = false;
            });
    }
  }

  onRowCollapse(event: TableRowCollapseEvent) {
    //console.debug('onRowCollapse', event, this.expandedRows);
  }

  doPrepareReleaseItems(): void {

    if (this.loadingPrepareReleaseItems)
      return;
    this.loadingPrepareReleaseItems = true;
    this.apiService.PrepareReleaseItems()
      .forEach(
        (result) => {
          this.alertService.info(result || 'Requested');
          this.loadingPrepareReleaseItems = false;
        }).catch(
          err => {
            this.alertService.error(Utils.getAjaxError(err));
            this.loadingPrepareReleaseItems = false;
          });
  }

  doReleaseToProduction(): void {
    if (this.loadingReleaseToProduction)
      return;
    this.alertService.confirm('Are you sure you want to release to production? This action cannot be undone.', 'Release To Production')
      .subscribe(response => {
        if (response) {
          this.loadingReleaseToProduction = true;
          this.apiService.ReleaseToProduction()
            .forEach(
              (result) => {
                this.alertService.info(result || 'Requested');
                this.loadingReleaseToProduction = false;
              }).catch(
                err => {
                  this.alertService.error(Utils.getAjaxError(err));
                  this.loadingReleaseToProduction = false;
                });
          }
      });
  }

  doArchiveReleaseItems(): void {
    if (this.loadingArchiveReleaseItems)
      return;
    this.alertService.confirm('Are you sure you want to archive release items? This action cannot be undone.', 'Archive Release Items')
      .subscribe(response => {
        if (response) {
          this.loadingArchiveReleaseItems = true;
          this.apiService.ArchiveReleaseItems()


            .forEach(
              (result) => {
                this.alertService.info(result || 'Requested');
                this.loadingArchiveReleaseItems = false;
              }).catch(
                err => {
                  this.alertService.error(Utils.getAjaxError(err));
                  this.loadingArchiveReleaseItems = false;
                });
        }
      });

  }

 

}
